import { css } from '@emotion/react';

interface LexicalBulletListStylesOptions {
  circleClass: string;
  discClass: string;
  squareClass: string;
}

export function createLexicalBulletListStyles({
  circleClass,
  discClass,
  squareClass,
}: LexicalBulletListStylesOptions) {
  return css`
    .${discClass}, .${circleClass}, .${squareClass} {
      list-style-position: outside;
    }

    .${discClass} {
      list-style-type: disc;
    }

    .${circleClass} {
      list-style-type: circle;
    }

    .${squareClass} {
      list-style-type: square;
    }
  `;
}

interface LexicalCheckListStylesOptions {
  checkedClass: string;
  uncheckedClass: string;
}

export function createLexicalCheckListStyles({
  checkedClass,
  uncheckedClass,
}: LexicalCheckListStylesOptions) {
  return css`
    .${checkedClass}, .${uncheckedClass} {
      position: relative;
      margin-left: var(--ck-spacing-2);
      margin-right: var(--ck-spacing-2);
      padding-left: var(--ck-spacing-6);
      padding-right: var(--ck-spacing-6);
      list-style-type: none;
      outline: none;
    }

    .${checkedClass} {
      text-decoration: line-through;
    }

    .${checkedClass}::before, .${uncheckedClass}::before {
      content: '';
      width: var(--ck-spacing-4);
      height: var(--ck-spacing-4);
      top: 2px;
      left: 0;
      cursor: pointer;
      display: block;
      position: absolute;
      border: 1px solid var(--chakra-colors-gray-400);
      border-radius: var(--chakra-radii-sm);
    }

    .${checkedClass}[dir='rtl']::before,
    .${uncheckedClass}[dir='rtl']::before {
      left: auto;
      right: 0;
    }

    .${checkedClass}:focus::before, .${uncheckedClass}:focus::before {
      box-shadow: 0 0 0 2px var(--chakra-colors-blue-100);
    }

    .${checkedClass}::before {
      border-color: var(--chakra-colors-blue-500);
      background-color: var(--chakra-colors-blue-500);
    }

    .${checkedClass}::after {
      content: '';
      cursor: pointer;
      border-color: var(--ck-color-white);
      border-style: solid;
      position: absolute;
      display: block;
      top: 6px;
      left: 7px;
      width: 3px;
      height: 6px;
      transform: rotate(45deg);
      border-width: 0 2px 2px 0;
    }
  `;
}
